/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback} from "react"
import {KlassDropdown, KlassDropdownAsyncProps} from "../Select"
import {useGroupedOutcomes} from "hooks/useAllOutcomes"
import {Settings} from "types/settings"
import {isEmpty} from "lodash"

type Props = Partial<KlassDropdownAsyncProps> & {
    outcomes?: Settings.Outcome[]
}

export const OutcomeSelect: React.FC<Props> = ({outcomes, ...props}) => {
    const groupedOutcomes = useGroupedOutcomes()

    const getOptionLabel = useCallback((option: Settings.Outcome) => option.name, [])

    return (
        <KlassDropdown
            {...props}
            options={outcomes ?? groupedOutcomes}
            valueKey="outcomeId"
            labelKey="name"
            getOptionLabel={getOptionLabel}
        />
    )
}
